import { configureStore } from '@reduxjs/toolkit'
import onboardingSlice from './features/main/onboardingSlice'
import reviewReducer from './features/review/reviewSlice'
import contentLibrarySlice from './features/content_library/contentLibrarySlice'
import notificationSlice from './features/notification/notificationSlice'
import rewardsSlice from './features/rewards/rewardsSlice'
import searchSlice from './features/main/searchSlice'
import leaderboardsSlice from './features/leaderboards/leaderboardsSlice'
import upcomingEventsSlice from './features/upcoming_events/upcomingEventsSlice'
import localizationSlice from './features/main/localizationSlice'
import invalidTokenSlice from './features/main/invalidTokenSlice'
import learningJourneySlice from './features/learning_journey/learningJourneySlice'

export const store = configureStore({
  reducer: {
    review: reviewReducer,
    content_library: contentLibrarySlice,
    notification: notificationSlice,
    onboarding: onboardingSlice,
    rewards:rewardsSlice,
    leaderboard: leaderboardsSlice,
    upcoming_events: upcomingEventsSlice,
    search:searchSlice,
    localization:localizationSlice,
    invalidT:invalidTokenSlice,
    learning_journey:learningJourneySlice
  },
})